import PropTypes from 'prop-types';

export const props = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
};
